import React, { memo } from "react";
import { Box, Typography } from "@mui/material";

const WireInstructionsUploadRequest = () => {
  return (
    <Box
      data-testid="wire-instructions-upload-request"
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight={200}
    >
      <Typography variant="bodySubhead2">WIP</Typography>
    </Box>
  );
};

export default memo(WireInstructionsUploadRequest);
